import React from 'react';

const fieldStyle = { borderColor: 'var(--zg-border)', background: 'var(--zg-field)', color: 'var(--zg-ink)' };

const handleFocus = (e) => {
  e.currentTarget.style.borderColor = '#e08e0b';
  e.currentTarget.style.background = 'var(--zg-card)';
  e.currentTarget.style.boxShadow = '0 0 0 4px rgba(224,142,11,.12)';
};
const handleBlur = (e) => {
  e.currentTarget.style.borderColor = 'var(--zg-border)';
  e.currentTarget.style.background = 'var(--zg-field)';
  e.currentTarget.style.boxShadow = 'none';
};

export const FieldLabel = ({ children, htmlFor }) => (
  <label htmlFor={htmlFor} className="text-[13px] font-semibold inline-block mb-0.5" style={{ color: 'var(--zg-ink)' }}>
    {children}
  </label>
);

export const FieldInput = ({ className = '', ...props }) => (
  <input
    {...props}
    className={`w-full box-border mt-1.5 border-[1.5px] rounded-xl px-[15px] py-[13px] text-[15px] transition-colors focus:outline-none ${className}`}
    style={fieldStyle}
    onFocus={handleFocus}
    onBlur={handleBlur}
  />
);

export const FieldTextarea = ({ className = '', ...props }) => (
  <textarea
    {...props}
    className={`w-full box-border mt-1.5 border-[1.5px] rounded-xl px-[15px] py-[13px] text-[15px] resize-none transition-colors focus:outline-none ${className}`}
    style={fieldStyle}
    onFocus={handleFocus}
    onBlur={handleBlur}
  />
);
